import { ReactElement } from 'react';

const YoutubeIcon = (props: TClassNameProps): ReactElement => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.7895 6.18699C20.6511 6.41869 21.3231 7.09707 21.5562 7.96338C22.1656 10.4349 22.1259 15.1076 21.569 17.6176C21.3385 18.484 20.6639 19.1598 19.8024 19.394C17.3701 19.999 6.47596 19.9244 4.18448 19.394C3.32294 19.1623 2.65086 18.484 2.41787 17.6176C1.84308 15.262 1.88277 10.2804 2.40507 7.97625C2.6355 7.10994 3.31014 6.43414 4.17168 6.19986C7.42326 5.51763 18.6323 5.73775 19.7895 6.18699ZM10.0603 9.77846L15.2833 12.7906L10.0603 15.8027V9.77846Z"
			fill="currentColor"
		/>
	</svg>
);

export default YoutubeIcon;
